var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader"},[(_vm.showValue)?_c('p',{staticClass:"text",attrs:{"id":"cont"}},[_vm._v("\n    "+_vm._s(_vm.value +'%')+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }